import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Nachbarschaft/neighbour_1",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_3",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_2",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_4",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_6",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_8",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_10",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_14",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_15",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_7",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_5",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_9",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_11",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_12",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Nachbarschaft/neighbour_13",
	    "orientation": "portrait"
	  }
	]
}

export default class Nachbarschaft extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Nachbarschaft" 
			text="Für die erste Version dieser Fotoserie habe ich die Wohnungstüren meines Wohnhauses fotografiert. Die zweite Version 
			zeigte die Haustüren meines Häuserblocks. Das Endprodukt wurde weiter auf die Fläche der Fassade von den Häusern reduziert.
			Während diesem Projekt habe ich gelernt, dass man Ideen immer weiterentwickeln und verschiedenes ausprobieren sollte, bis 
			einen das Endprodukt zufrieden stellt. Während diesem Projekt habe ich mich intensiv mit der Präsentationsform von Bildern 
			beschäftigt. Die Fotoserie wurde auf strukturiertem Papier ausgedruckt, da dieses die visuelle Struktur der Hausfassaden 
			auf den Fotos weiter verstärkt hat." 
			images={projectElements.images}
			layout="dreier"/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/neighbour.js